import React from "react";
import styles from "./ecosystem.module.css";
import { useEffect, useRef, useState } from "react";

function Ecosystem() {
  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  return (
    <div id="ecosystem" className={styles.ecosystem_wrapper}>
      <div className={styles.ecosystem_container}>
        <div
          ref={pRef}
          className={`${styles.ecosystemHeading} ${
            isVisible ? styles.show : ""
          }`}>
          <h2>
            Business <br /> Ecosystem
          </h2>
          <h3>What is BusinessCorners?</h3>
          <div className={styles.ecoLine}></div>
        </div>
        <div
          ref={pRef}
          className={`${styles.ecosystemText} ${isVisible ? styles.show : ""}`}>
          <p className={styles.upperText}>
            At <span>BusinessCorners</span> , we believe that success lies in
            the balance between various business elements. Our Business Corners
            is dedicated to fostering synergy between buyers, suppliers,
            products, and markets. We aim to create a space where businesses can
            seamlessly navigate market entry, develop strong supply chains, and
            expand their global reach.
          </p>
          <p className={styles.lowerText}>
            By leveraging our deep industry knowledge and extensive network, we
            provide businesses with the tools and connections they need to
            thrive in the European market. Whether you’re looking to grow your
            product visibility or establish a secure supply chain, the
            <span> Business Corners</span> is your gateway to sustainable,
            long-term success.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Ecosystem;
